import { groupBy, remap } from "../utils";

export const traits = {
    "D": {name: "Dominância", color: "red"},
    "I": {name: "Influência", color: "yellow"},
    "S": {name: "Estabilidade", color: "red"},
    "C": {name: "Conformidade", color: "red"}
} as const

export type Trait = keyof typeof traits;

export type Question = {
    index: number,
    text: string,
    options: {text: string, type: Trait}[]
    selected?: Trait
}

export type QuestionData = {
    text: string,
    options: Record<Trait, string>
}

export type Page = {
    questions: Question[]
}

export type TraitResult = {first:Trait, second: Trait, result: Record<Trait, number>}

export function pagesToResult(pages:Page[]):TraitResult{
    const all = pages.flatMap(p => p.questions)
    const grouped = groupBy(all, q => q.selected);
    const result = remap(grouped, i => i.length);
    const entries = Object.entries(result);
    entries.sort(([_0, a], [_1, b]) => b - a);
    return {first: entries[0][0] as Trait, second: entries[1][0] as Trait, result};
}

export type Lead = {
    name: string
    phone: string
    email: string
}

export const exResult:TraitResult = {
    first: "D",
    second: "C",
    result: {
        D: 12,
        C: 7,
        I: 0,
        S: 1
    }
}